'use strict'

class Auth {
    
    init () {
        $('#profileDropdown').on('click', function(e) {
            e.preventDefault();
                if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $('#profileMenu').slideUp();
            } else {
                $(this).addClass('active');
                $('#profileMenu').slideDown();
            }
        });
    }
}

export default Auth;